import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";
import { cn } from "../../libs/utils";

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
    percent?: boolean;
  }
>(({ className, percent, value, ...props }, ref) => (
  <ProgressPrimitive.Root
    className={cn(
      "relative h-3 w-full bg-primary/20 mt-7 rounded-full",
      className
    )}
    ref={ref}
    {...props}
  >
    {value && percent ? (
      <span
        className="absolute bg-primary text-white text-xs px-2 py-2 rounded font-bold bottom-6 -translate-x-5"
        style={{ left: `${value}%` }}
      >
        {Math.round(value || 0)}%
        <span
          className="border-transparent border-t-primary"
          style={{
            position: "absolute",
            bottom: "-18px",
            left: "50%",
            transform: "translateX(-50%)",
            borderWidth: "9px",
            borderStyle: "solid",
          }}
        />
      </span>
    ) : null}
    <div className="overflow-hidden w-full h-full rounded-full">
      <ProgressPrimitive.Indicator
        className="h-full w-full rounded-full flex-1 bg-primary transition-all relative"
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </div>
  </ProgressPrimitive.Root>
));

Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
